import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module'
import { InputContainer } from '../../../../../../common/components/form/form.module'

export const TasksBasicInfoComponent = ({
    handleInnerFormChange, sourceType, selectedTasks, taskStatus, relatedToTypes, 
    contacts, leads, opportunities, campaign, accounts
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div>
                        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                            <InputContainer
                                label="Subject"
                                name="Subject"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Subject'
                                    )
                                }}
                                type="text"
                                value={selectedTasks?.Subject}
                            />
                            <InputContainer
                                label="Status"
                                labelField="Text"
                                list={taskStatus}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Status'
                                    );
                                }}
                                optionName='Choose Status'
                                type="select"
                                value={selectedTasks?.Status}
                                valueField="Value"
                            />
                            <InputContainer
                                label="StartDate"
                                name="StartDate"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'StartDate'
                                    )
                                }}
                                type="date"
                                value={selectedTasks?.StartDate}
                            />
                            <InputContainer
                                label="EndDate"
                                name="EndDate"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'EndDate'
                                    )
                                }}
                                type="date"
                                value={selectedTasks?.EndDate}
                            />
                            <InputContainer
                                label="Source Type"
                                labelField="RelatedToType"
                                list={sourceType}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'SourceTypeId'
                                    );
                                }}
                                optionName='Choose Source Type'
                                type="select"
                                value={selectedTasks?.SourceTypeId}
                                valueField="RelatedToTypeId"
                            />
                            {selectedTasks?.SourceTypeId === 9 &&
                                <InputContainer
                                label="Source"
                                labelField="FirstName"
                                list={leads}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'SourceId'
                                    );
                                }}
                                optionName='Choose leads'
                                type="select"
                                value={selectedTasks?.SourceId}
                                valueField="Id"
                            />
                            }
                            {selectedTasks?.SourceTypeId === 11 &&
                                <InputContainer
                                label="Source"
                                labelField="FirstName"
                                list={contacts}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'SourceId'
                                    );
                                }}
                                optionName='Choose Contact'
                                type="select"
                                value={selectedTasks?.SourceId}
                                valueField="Id"
                            />
                            }
                            <InputContainer
                                label="Related To Type"
                                labelField="RelatedToType"
                                // list={relatedToTypes}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'RelatedToTypeId'
                                    );
                                }}
                                optionName='Choose RelatedToType'
                                type="select"
                                value={selectedTasks?.RelatedToTypeId}
                                valueField="RelatedToTypeId"
                            />
                            {selectedTasks?.RelatedToTypeId === 13 &&
                                <InputContainer
                                label="Related To"
                                labelField="Name"
                                list={opportunities}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'RelatedToId'
                                    );
                                }}
                                optionName='Choose Opportunity'
                                type="select"
                                value={selectedTasks?.RelatedToId}
                                valueField="Id"
                            />
                            }
                            {selectedTasks?.RelatedToTypeId === 46 &&
                                <InputContainer
                                label="Related To"
                                labelField="Text"
                                list={campaign}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'RelatedToId'
                                    );
                                }}
                                optionName='Choose Campaign'
                                type="select"
                                value={selectedTasks?.RelatedToId}
                                valueField="Value"
                            />
                            }
                            {selectedTasks?.RelatedToTypeId === 99 &&
                                <InputContainer
                                label="Related To"
                                labelField="Name"
                                list={accounts}
                                onValueChange={(event: any, newValue: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'RelatedToId'
                                    );
                                }}
                                optionName='Choose Account'
                                type="select"
                                value={selectedTasks?.RelatedToId}
                                valueField="Id"
                            />
                            }
                        </div>
                        <div className=' grid md:grid-cols-1 lg:grid-cols-1 gap-1 pt-4'>
                            <InputContainer
                                label="Body"
                                name="Body"
                                onValueChange={(event: any) => {
                                    handleInnerFormChange(
                                        event.target.value,
                                        'Body'
                                    )
                                }}
                                type="text"
                                value={selectedTasks?.Body}
                            />
                        </div>
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    )
}

export default TasksBasicInfoComponent;
